let instance = null;
export const setLenis = (l) => {
  instance = l;
};
export const getLenis = () => instance;
